import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from "rxjs";
import { RoutingUtils } from 'src/app/utils';
import { ValidateIntegrationService } from '../http/validate-integration.service';
import { SESSION_KEYS } from 'src/app/shared/constants/params.constant';
import { StorageService } from 'src/app/shared/service/storage.service';

@Injectable({
  providedIn: 'root'
})
export class SplashService {
  isOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(
    private validateIntegrationService: ValidateIntegrationService,
    private router: Router,
    private storageService: StorageService
  ) {
    this.validateIntegration();
  }

  validateIntegration(): void {
    this.validateIntegrationService.validateCodeIntegration()
      .subscribe({
        next: ({ loginCiam }) => {
          // IMPLEMENTAR:
          this.storageService.set(SESSION_KEYS.ISLOGINCIAM, JSON.stringify(!!loginCiam));
          this.storageService.set(SESSION_KEYS.SUCCESSVALIDATION, JSON.stringify(true));
          this.router.navigate([RoutingUtils.AtRoot(RoutingUtils.Routes.AUTHENTICATION)]);
          this.hideSplash();
        },
        error: () => {
          // IMPLEMENTAR:
          this.storageService.set(SESSION_KEYS.SUCCESSVALIDATION, JSON.stringify(false))
          this.router.navigate([RoutingUtils.AtRoot(RoutingUtils.Routes.FAILED)]);
          this.hideSplash()
        }
      });
  }

  hideSplash(): void {
    setTimeout(() => {
      this.isOpen.next(false);
    }, 300);
  }
}
